import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Tag, Plus, Trash } from "@phosphor-icons/react";

export default function Categories() {
  const [cats, setCats] = useState([]);
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const { data } = await api.get("/categories");
    setCats(data);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    await api.post("/categories", { name: name.trim() });
    setName("");
    load();
  };

  const remove = async (id) => {
    if (!confirm("¿Eliminar esta categoría?")) return;
    await api.delete(`/categories/${id}`);
    load();
  };

  const predefined = cats.filter((c) => c.is_predefined);
  const custom = cats.filter((c) => !c.is_predefined);

  return (
    <div className="max-w-4xl mx-auto space-y-10" data-testid="categories-page">
      <div>
        <p className="eyebrow mb-3">organiza tu recetario</p>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight">Categorías</h1>
        <p className="mt-3 text-[hsl(var(--muted-foreground))]">Usa las predefinidas o crea las tuyas propias para clasificar mejor tus recetas.</p>
      </div>

      <form onSubmit={create} className="pill-input flex items-center gap-3">
        <Plus size={18} className="text-[hsl(var(--muted-foreground))]" />
        <input
          data-testid="new-category-input"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Nombre de la nueva categoría…"
          className="bg-transparent outline-none w-full text-sm"
        />
        <button data-testid="new-category-submit" type="submit" className="shrink-0 px-4 py-2 rounded-full bg-[hsl(var(--primary))] text-white text-sm font-semibold btn-press">
          Crear
        </button>
      </form>

      {loading ? (
        <p className="text-[hsl(var(--muted-foreground))]">Cargando…</p>
      ) : (
        <>
          <section>
            <p className="eyebrow mb-4">predefinidas</p>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
              {predefined.map((c) => (
                <div key={c.id} data-testid={`category-item-${c.id}`} className="rounded-2xl bg-white border border-[hsl(var(--border))] p-4 flex items-center gap-3">
                  <Tag size={18} className="text-[hsl(var(--primary))]" />
                  <span className="text-sm font-medium">{c.name}</span>
                </div>
              ))}
            </div>
          </section>

          <section>
            <p className="eyebrow mb-4">tuyas</p>
            {custom.length === 0 ? (
              <p className="text-sm text-[hsl(var(--muted-foreground))]">Aún no has creado categorías personalizadas.</p>
            ) : (
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
                {custom.map((c) => (
                  <div key={c.id} data-testid={`category-item-${c.id}`} className="rounded-2xl bg-white border border-[hsl(var(--border))] p-4 flex items-center justify-between gap-2">
                    <div className="flex items-center gap-2 min-w-0">
                      <Tag size={18} className="text-[hsl(var(--secondary))] shrink-0" />
                      <span className="text-sm font-medium truncate">{c.name}</span>
                    </div>
                    <button onClick={() => remove(c.id)} data-testid={`category-delete-${c.id}`} className="text-[hsl(var(--destructive))] btn-press">
                      <Trash size={16} />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </section>
        </>
      )}
    </div>
  );
}
